import { create } from "zustand";
import { persist } from "zustand/middleware";
import { getOrderDefaultFilter } from "../utils/store.helper";

const useOrderStore = create(
  persist(
    (set) => ({
      orderRecordsFilter: getOrderDefaultFilter(),
      hasFetchedOrders: false,
      shouldFetchOrderRecords: true,
      shouldFetchDashboardOrders: true,
      orderRecords: [],
      dashboardOrders: [],
      orderRecordsTotal: 0,
      newOrderId: '',
      setNewOrderId: (val) => {
        set({newOrderId: val})
      },
      setHasFetchedOrders: (val) => {
        set({ hasFetchedOrders: val });
      },
      setShouldFetchOrderRecords: (val) => {
        set({ shouldFetchOrderRecords: val });
      },
      setShouldFetchDashboardOrders: (val) => {
        set({ shouldFetchDashboardOrders: val });
      },
      setOrderRecordsFilter: (filter) => {
        set({ orderRecordsFilter: filter });
      },
      setOrderRecordsTotal: (total) => {
        set({ orderRecordsTotal: total });
      },
      setOrderRecords: (orders) => {
        set({ orderRecords: orders });
      },
      setDashboardOrders: (orders) => {
        set({ dashboardOrders: orders });
      },
      prependOrderRecord: (order) => {
        set((state) => {
          const exists = state.orderRecords.some((o) => o._id === order._id);

          if (exists) {
            return state; // no change if already exists
          }

          return {
            orderRecords: [order, ...state.orderRecords],
            dashboardOrders: [order, ...state.dashboardOrders],
          };
        });
      },
      updateOrderRecord: (updatedOrder) => {
        if (updatedOrder.status === "cancelled" && updatedOrder.paid === 0) {
          set((state) => ({
            orderRecords: state.orderRecords.filter(
              (order) => !(order._id === updatedOrder._id && updatedOrder.status === "cancelled")
            ),

            dashboardOrders: state.dashboardOrders.filter(
              (order) => !(order._id === updatedOrder._id && updatedOrder.status === "cancelled")
            ),
          }));
        } else {
          set((state) => ({
            orderRecords: state.orderRecords.map((order) =>
              order._id === updatedOrder._id ? { ...order, ...updatedOrder } : order
            ),

            dashboardOrders: state.dashboardOrders.map((order) =>
              order._id === updatedOrder._id ? { ...order, ...updatedOrder } : order
            ),
          }));
        }
      },
    }),
    {
      name: "order-storage",
      getStorage: () => localStorage,
    }
  )
);

export default useOrderStore;
